import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Seo, Reveal } from "../components/Seo";
import { PageHero, CtaBand } from "../components/blocks";
import { SERVICES } from "../lib/site";

export default function Services() {
  return (
    <>
      <Seo
        title="Enterprise Technology Services — Softline Nigeria"
        description="Solution architecture, cloud and infrastructure, cybersecurity, software engineering, systems integration, and data and digital transformation services."
        path="/services"
      />
      <PageHero
        eyebrow="Enterprise services"
        title={["Six practices.", "One delivery discipline."]}
        lead="Structured engagement models, credible deliverables and senior engineers — from architecture through operations."
        crumbs={[{ label: "Home", to: "/" }, { label: "Services" }]}
      />

      <section className="bg-white" data-testid="services-list">
        <div className="shell py-24 md:py-32">
          <div className="grid md:grid-cols-2 gap-px bg-charcoal/10 border border-charcoal/10">
            {SERVICES.map((s, i) => (
              <Reveal key={s.slug} delay={i * 0.05} className="h-full">
                <Link
                  to={`/services/${s.slug}`}
                  data-testid={`services-card-${s.slug}`}
                  className="group flex flex-col h-full bg-white p-8 md:p-10 hover:bg-surface transition-colors duration-200"
                >
                  <div className="flex items-center justify-between">
                    <span className="font-mono text-xs text-charcoal/50">{s.num}</span>
                    <ArrowUpRight size={20} className="text-charcoal/30 group-hover:text-lime transition-colors duration-200" />
                  </div>
                  <h2 className="font-display font-bold text-2xl mt-6">{s.name}</h2>
                  <p className="mt-4 text-[15px] leading-relaxed text-charcoal/65">{s.short}</p>
                  <div className="mt-6 flex flex-wrap gap-2">
                    {s.industries.slice(0, 2).map((ind) => (
                      <span key={ind} className="font-mono text-[10px] uppercase tracking-[0.15em] border border-charcoal/15 text-charcoal/55 px-3 py-1">
                        {ind}
                      </span>
                    ))}
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.1}>
            <p className="mt-10 text-sm text-charcoal/55 max-w-3xl" data-testid="services-note">
              Engagements are described in terms of deliverables and realistic outcomes. We do not claim vendor partner
              status, managed-service operations or certifications that we have not verified and documented.
            </p>
          </Reveal>
        </div>
      </section>

      <CtaBand />
    </>
  );
}
